<template>
  <div class="row kham-pha">
    <div class="col-12 header-kham-pha">
      <div class="w-75 float-left profile">
        <img
          src="../../assets/img/dummy/u1.png"
          alt="avatar cua toi">
        <p>Nguyễn Văn Tèo</p>
      </div>
      <div class="float-right profile-detail">
        <router-link to="/">
          <i class="fa fa-cog"/>
          <p>Thiết lập</p>
        </router-link>
      </div>
    </div>
    <div class="col-12 my-2 content-kham-pha">
      <div class="row">
        <div class="col-4">
          <router-link to="/upgrade-account">
            <div class="row">
              <div class="card mx-2">
                <img
                  src="../../assets/images/kham-pha-1.png"
                  class="card-img-top"
                  alt="...">
                <div class="card-body">
                  <p class="card-text">Gia hạn gói vip</p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-4">
          <router-link to="/lixi">
            <div class="row">
              <div class="card mx-2">
                <img
                  src="../../assets/images/kham-pha-2.png"
                  class="card-img-top"
                  alt="...">
                <div class="card-body">
                  <p class="card-text">Lì xì phong thuỷ</p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-4">
          <router-link to="/">
            <div class="row">
              <div class="card mx-2">
                <img
                  src="../../assets/images/kham-pha-3.png"
                  class="card-img-top"
                  alt="...">
                <div class="card-body">
                  <p class="card-text">Xem ngày tháng tốt</p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Index'
  }
</script>

<style scoped>
    .kham-pha {
        background-color: #fff;
        border-top:1px solid #e2e3e5;
        border-bottom:1px solid #e2e3e5;
    }
    .header-kham-pha {
      width: 100%;
      height: auto;
      padding: 5px 10px;
      border-bottom: 1px solid #d2d6de;
    }
    .header-kham-pha img {
        width: 35px;
        height: 35px;
        border-radius: 50%;
    }
    .profile p {
      color: #000;
      font-size: 0.9rem;
      margin-bottom: 0;
    }
    .profile p:hover {
      text-decoration: none;
    }
    .profile-detail {
      position: relative;
      right: 10px;
      top: 30%;
    }
    .profile-detail .fa-cog {
      margin-left: 17px;
      color: #69C15D;
      font-size: 18px;
    }
    .profile-detail p {
      font-size: 0.9rem;
      color: #000;
    }
    .content-kham-pha {
      width: 100%;
      height: auto;
    }
    .content-kham-pha .card-text {
        color: #0a0a0a;
        text-decoration: none;
        text-align: center;
    }
    .content-kham-pha .card .card-body {
        padding: 0.3rem;
    }
    .content-kham-pha .card .card-body .card-text:hover {
        text-decoration: none;
    }
    .content-kham-pha .card {
        border-radius: 16px;
        height: 100px;
        max-height: 100px;
        -webkit-box-shadow: 0 10px 6px -6px #777;
        -moz-box-shadow: 0 10px 6px -6px #777;
        box-shadow: 0 8px 6px -6px #777;
    }
    .content-kham-pha .card img {
        border-radius: 16px 16px 0 0 ;
        border-bottom: 1px solid #f3f5f8;
    }
</style>



// WEBPACK FOOTER //
// src/components/kham-pha/Index.vue